import { useContext } from 'react';
import { CombinedFeedContext } from '../../../context/CombinedFeedContext';

//component
import ModalWrapper from '../ModalWrapper';
import FeedModeSelector from  '@/components/elements/combinedFeed/FeedModeSelector';
import SourceListSelector from  '@/components/elements/combinedFeed/SourceListSelector/SourceListSelector';

//interfaces
import { modeType } from  '@/interfaces/CombinedFeed';

import "../../../css/modals/sourceListsModal.scss";


const CombinedFeedModal = () => {
    const {handleModalClose, modalOpen, showFeedModeSelectionPanel, setSourceListModeType, modalIsLoading} = useContext(CombinedFeedContext);

    if (!modalOpen){
        return <></>
    }
    return (
        <ModalWrapper isOpen={modalOpen} onRequestClose={handleModalClose} className={`${showFeedModeSelectionPanel ? "feed-type-modal" : "source-list-modal"} ${modalIsLoading ? "is-setting-mode" : ""}`} children={  
            <>
            {showFeedModeSelectionPanel
                ?   <FeedModeSelector 
                        isLoading={modalIsLoading}
                        setFeedModeToAll={()=>{setSourceListModeType(modeType.all), handleModalClose()}} 
                        setFeedModeToSelected={()=>setSourceListModeType(modeType.selected)}
                    />

                :   <SourceListSelector />
            }
            </>
        }
        />
    );  
}

export default CombinedFeedModal;